// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px) {
  html.control-contracts-page-lock,
  body:has(.control-contracts-page) {
    overflow-y: hidden;
  }

  body:has(.control-contracts-page) #root,
  body:has(.control-contracts-page) .wrapper,
  .control-contracts-page,
  .control-contracts-page .layout-container,
  .control-contracts-page .layout-page {
    height: 100dvh;
    min-height: 0;
  }

  .control-contracts-page {
    overflow: hidden;
  }

  .control-contracts-page .content-wrapper {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .control-contracts-page .container-fluid.container-p-y {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    overflow: hidden;
  }

  .control-contracts-page .control-contracts-heading {
    flex: 0 0 auto;
  }

  .control-contracts-page .control-contracts-table-card {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .control-contracts-page .control-contracts-table-wrapper {
    height: auto !important;
    min-height: 0;
    max-height: 100%;
    flex: 1 1 auto;
    overflow-y: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/controlContracts.css"],"names":[],"mappings":"AAAA;EACE;;IAEE,kBAAkB;EACpB;;EAEA;;;;;IAKE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,2BAA2B;EAC7B;AACF","sourcesContent":["@media (min-width: 768px) {\n  html.control-contracts-page-lock,\n  body:has(.control-contracts-page) {\n    overflow-y: hidden;\n  }\n\n  body:has(.control-contracts-page) #root,\n  body:has(.control-contracts-page) .wrapper,\n  .control-contracts-page,\n  .control-contracts-page .layout-container,\n  .control-contracts-page .layout-page {\n    height: 100dvh;\n    min-height: 0;\n  }\n\n  .control-contracts-page {\n    overflow: hidden;\n  }\n\n  .control-contracts-page .content-wrapper {\n    display: flex;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .control-contracts-page .container-fluid.container-p-y {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .control-contracts-page .control-contracts-heading {\n    flex: 0 0 auto;\n  }\n\n  .control-contracts-page .control-contracts-table-card {\n    display: flex;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .control-contracts-page .control-contracts-table-wrapper {\n    height: auto !important;\n    min-height: 0;\n    max-height: 100%;\n    flex: 1 1 auto;\n    overflow-y: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
